// ------------------ IMPORTS -------------------

// Components
import { BadgeV2 } from "#src/commonV2/badges/Badge";
import { BadgeSeeMoreV2 } from "#src/commonV2/badges/BadgeSeeMore";

// Others
import { ReactNode } from "react";
import { Monitor01, User01, Users01 } from "@untitled-ui/icons-react";
import {
  IPassportDestination,
  IPassportSource,
} from "#src/services/endpoint/passports/types";
import {
  PassportSourceDestinationHostType,
  PassportSourceDestinationUserType,
} from "#src/services/endpoint/passports/enums";

// ------------------ TYPES -------------------

interface TagListRendererProps {
  items: IPassportSource[] | IPassportDestination[];
}

// ------------------ COMPONENT -------------------

export const TagListRenderer = ({ items }: TagListRendererProps) => {
  const tagList = items.map((item) => {
    const tag = {
      label: item.name,
      defaultIcon: false,
      noColor: true,
      icon: undefined as ReactNode,
    };

    switch (item.type) {
      case PassportSourceDestinationHostType.HOST:
        tag.icon = <Monitor01 className="h-3 w-3 min-w-3" />;
        break;
      case PassportSourceDestinationHostType.TAG:
        tag.defaultIcon = true;
        tag.noColor = false;
        break;
      case PassportSourceDestinationUserType.USER:
        tag.icon = <User01 className="h-3 w-3 min-w-3" />;
        break;
      case PassportSourceDestinationUserType.DEPARTMENT:
        tag.icon = <Users01 className="h-3 w-3 min-w-3" />;
        break;
    }
    return tag;
  });

  return (
    <>
      {tagList.length > 0 ? (
        <BadgeV2
          name={tagList[0].label}
          defaultIcon={tagList[0].defaultIcon}
          color={tagList[0].noColor ? "gray" : undefined}
          leftIcon={tagList[0].icon}
        />
      ) : null}
      {tagList.length > 1 ? (
        <BadgeV2
          name={tagList[1].label}
          defaultIcon={tagList[1].defaultIcon}
          color={tagList[1].noColor ? "gray" : undefined}
          leftIcon={tagList[1].icon}
        />
      ) : null}
      <BadgeSeeMoreV2
        badges={tagList.slice(2).map((tag) => (
          <BadgeV2
            key={tag.label}
            name={tag.label}
            defaultIcon={tag.defaultIcon}
            color={tag.noColor ? "gray" : undefined}
            leftIcon={tag.icon}
          />
        ))}
      />
    </>
  );
};
